import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBambooComponent } from './simple-icons-bamboo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBambooComponent ],
    exports:      [ SimpleIconsBambooComponent ],
    bootstrap:    []
})
export class SimpleIconsBambooModule {}
